import { render, staticRenderFns } from "./VesselFiles.vue?vue&type=template&id=f363a0a8&scoped=true&"
import script from "./VesselFiles.vue?vue&type=script&lang=js&"
export * from "./VesselFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f363a0a8",
  null
  
)

export default component.exports